import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { OvsComponent } from '../shared/core/ovs.core';
import { ResortDetail, ResortImageType, ResortImage } from '../models/presentation.model';
import { ResortComponent } from '../shared/resort.component';

@Component({
  selector: 'resort-extra',
  templateUrl: './resort-extra.component.html',
  styleUrls: ['./resort-extra.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResortExtraComponent extends ResortComponent 
{
    @Input()
    public resort: ResortDetail;
    @Input()
    public imageTypes: ResortImageType[];
    @Input()
    public title: string;

    constructor()
    {
        super();
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-detail/resort-extra.component.ts